import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/out_25.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image120.webp';
import slideImg2 from '../images/image36.webp';
import slideImg3 from '../images/image97_.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const sarasotaSpringsConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Sarasota Springs Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Sarasota Springs, FL. Sam\'s Tree Service tackles dangerous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_sarasota_springs',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Sarasota Springs',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Sarasota Springs Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we provide the kind of expert tree care that 
     <strong>Sarasota Springs</strong> homeowners and businesses can count on. From large 
     oaks dropping limbs onto driveways and rooftops to palms leaning dangerously after 
     a storm, our crew takes on the jobs that require real experience and professional 
     equipment done right the first time.`,

    `We specialize in <strong>hazardous tree removal and targeted trimming</strong> 
     storm damaged limbs, trees with compromised root systems, overgrown canopies creating 
     risk to structures, and dense growth blocking sight lines or pressing against power 
     lines. Every job is handled with safety and precision from start to finish.`,

    `<strong>Sam's Tree Service</strong> delivers dependable tree care throughout 
     <strong>Sarasota Springs</strong> and the surrounding <strong>Sarasota</strong> 
     area keeping your property safe, clean, and well maintained no matter the season.`,
  ],

  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Sarasota Springs, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_SarasotaSprings = () => <LocationPage config={sarasotaSpringsConfig} />;
export default Services_SarasotaSprings;
